import React from 'react';
import '../AMFacilities.css';

export default function TermsFull() {
  return (
    <section className='am-terms am-section' aria-labelledby='terms-heading'>
      <div className='am-section-inner'>
        <h2 id='terms-heading' className='am-section-title'>
          Terms &amp; Conditions
        </h2>

        <p>
          By using AM Facilities' website and booking our cleaning services or home maintenance inspections, you agree
          to the following Terms &amp; Conditions. Our services cover office cleaning, residential cleaning, commercial
          janitorial services, and home maintenance inspections. Appointments must be scheduled in advance and are
          subject to availability. All pricing includes 13% HST. Payments are due upon service completion, and late
          payments beyond 7 days are subject to a 5% fee.
        </p>

        <p>
          Clients are responsible for ensuring access to the property at the scheduled time; failure to do so may result
          in a wait time charge of $25 per 30 minutes or a 100% cancellation fee. Cancellations made within 24 hours of
          the appointment are subject to a 50% fee, and last-minute cancellations within 2 hours will be charged 100% of
          the service cost. The final price for services will be determined based on the level of dirt, stains, and the
          overall condition of the area, and will be communicated to the client before work begins.
        </p>

        <p>
          A credit card pre-authorization of 15% of the first hour of service is required upon booking to secure the
          appointment. This pre-authorization amount will be applied toward the final service cost. If the client
          cancels within the allowed timeframe, the hold will be released. However, if the cancellation occurs within
          the last 24 hours, the pre-authorized amount will be retained as a cancellation fee.
        </p>

        <p>
          AM Facilities strives for 100% customer satisfaction. If you are unsatisfied with our service, please notify
          us within 12 hours of service completion, and we will assess the issue. We may offer a free re-clean of missed
          areas, subject to approval. We are not responsible for lost items, pre-existing property damage, or wear and
          tear. Clients must disclose any special cleaning needs or hazardous conditions before service begins.
        </p>

        <p>
          All content on our website is the property of A.M Facilities and may not be copied or redistributed. We
          respect client privacy and do not share personal information except for payment processing and legal
          requirements. These terms may be updated periodically, and continued use of our services implies acceptance of
          the latest version.
        </p>
      </div>
    </section>
  );
}
